import React from "react";
import _ from "lodash";
import {BettingTypesMap} from "../../../features/core/definitions";
import {FOBBetslip, FobSlipItem, getFobItemDisplayOdds, isFobItemPlayable, resolveFobItemHorses} from "../../../features/betslip/fob.service";

/**
 * Kupon panelindeki FOB (sabit ihtimalli) seçim listesi.
 *
 * `EkuriBetSlip` (masaüstü kenar çubuğu) ve `Betslip` (/bilet-onay tam sayfası) için tek
 * bileşen; fark yalnız BAŞLIK düzeni, o da `variant` ile geçiliyor.
 *
 * Eskiden bu dosyanın yarısı çift seçimin (İkili / Sıralı İkili) eş atını ve pazar
 * anahtarını column=1 / column=2 satırlarından yeniden TÜRETMEKLE geçiyordu - üstelik
 * anahtar sonekini elle ekleyip sonra `replaceAll` ile geri söküyordu. Yeni modelde seçim
 * zaten `oddKey` + `horseNos` taşıyor, o iş tamamen ortadan kalktı.
 */
export function FobSelectionList({slipItems, variant}: { slipItems: FobSlipItem[]; variant: "sidebar" | "page" }) {
    return (
        <>
            {_.orderBy(slipItems, [(e: FobSlipItem) => Number(e.run.no), "bettingType"], ["asc"]).map((slipItem: FobSlipItem, index: number) => {
                const {primaryHorse, secondHorse, label} = resolveFobItemHorses(slipItem);
                // Kim Geçer'de iki at RAKİP; İkili/Sıralı İkili'de ise ikisi de aynı bahsin
                // parçası. Ayrımı ayıraç taşıyor: "vs" karşılaşma, "-" birlikte seçim.
                const isH2HItem = !!BettingTypesMap[Number(slipItem.bettingType)]?.isHeadToHead;
                // Kim Geçer'de ilk at SEÇİLEN, ikincisi rakip; seçilen at vurgulanıyor.
                const horseName = !secondHorse
                    ? primaryHorse?.name
                    : isH2HItem
                        ? <><span className="h2h-picked-horse">{primaryHorse?.name}</span> vs {secondHorse?.name}</>
                        : `${primaryHorse?.name} - ${secondHorse?.name}`;
                const betTypeDefinition = BettingTypesMap[Number(slipItem.bettingType)]?.prefix;

                return (
                    <div key={"slip-item-" + index}>
                        {variant === "page" &&
                            <div className="coupon-subtitle">
                                <span className="text-xxsmall">{slipItem.hippodrome.hippodrome} {slipItem.run.no}. Koşu</span>
                                <span className={"text-xxsmall"}> {BettingTypesMap[Number(slipItem.bettingType)]?.name} </span>
                            </div>
                        }
                        <div className={`d-flex justify-content-between p-1 border-bottom ${!isFobItemPlayable(slipItem) ? 'bg-warning-subtle' : ''}`}>
                            <div className={"d-flex flex-column w-100"}>
                                {variant === "sidebar" &&
                                    <span className={"text-xsmall fw-bold"}>
                                        {slipItem.hippodrome.hippodrome} {slipItem.run.no}. Koşu {betTypeDefinition ? `(${betTypeDefinition})` : ''}
                                    </span>
                                }
                                <div className={"d-flex justify-content-between pe-1"}>
                                    <div>
                                        <span className="text-xxsmall  horse-no">({label}) </span>
                                        <span className="text-xxsmall  horse-name">{horseName}</span>
                                    </div>
                                    <div>
                                        <span className="text-xsmall fw-bold">{getFobItemDisplayOdds(slipItem)}</span>
                                    </div>
                                </div>
                                {!isFobItemPlayable(slipItem) &&
                                    <span className="text-xxsmall text-danger">Bu koşu kapandı, seçimi kaldırınız.</span>
                                }
                            </div>

                            <button className="button xs tertiary outlined delete "
                                    onClick={() => {
                                        FOBBetslip.remove(slipItem);
                                    }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                     viewBox="0 0 17 16" fill="none">
                                    <path
                                        d="M3.83329 5.33325V11.9999C3.83329 13.4727 5.0272 14.6666 6.49996 14.6666H10.5C11.9727 14.6666 13.1666 13.4727 13.1666 11.9999V5.33325M9.83329 7.33325V11.3333M7.16663 7.33325L7.16663 11.3333M11.1666 3.33325L10.2291 1.92698C9.98183 1.55605 9.56552 1.33325 9.11971 1.33325H7.88021C7.4344 1.33325 7.01809 1.55605 6.7708 1.92698L5.83329 3.33325M11.1666 3.33325H5.83329M11.1666 3.33325H14.5M5.83329 3.33325H2.49996"
                                        stroke="var(--primary-color)" strokeLinecap="round"
                                        strokeLinejoin="round"></path>
                                </svg>
                            </button>
                        </div>
                    </div>
                );
            })}
        </>
    );
}
